import {
  ACTION_TYPE_UNDEFINED,
  ACTION_TYPE_ADD_TAG,
  ACTION_TYPE_ADD_TAX_IDENTIFERS,
  ACTION_TYPE_SET_CARRIER_SERVICE_PACKAGE,
  ACTION_TYPE_INSURE_PACKAGE,
  ACTION_TYPE_REQUEST_CONFIRMATION,
  ACTION_TYPE_ADD_INTERNAL_NOTE,
  ACTION_TYPE_HOLD_ORDER_FOR,
  ACTION_TYPE_SET_CUSTOMS_CONTENT_TYPE,
  ACTION_TYPE_SET_INTERNATIONAL_NON_DELIVERY,
  ACTION_TYPE_SET_SHIP_FROM_LOCATION,
  ACTION_TYPE_STOP_PROCESSING_RULES,
  ACTION_TYPE_SEND_AN_EMAIL,
  ACTION_TYPE_CREATE_ALERT,
  ACTION_TYPE_SET_ORDER_TOTAL_WEIGHT,
  ACTION_TYPE_SET_PACKAGE_DIMENSIONS,
  ACTION_TYPE_DONT_IMPORT_ORDER,
  ACTION_TYPE_ADJUST_ORDER_WEIGHT,
  ACTION_TYPE_HOLD_UNTIL,
  ACTION_TYPE_MARK_SHIPMENT_NON_MACHINABLE,
  ACTION_TYPE_SHOW_POSTAGE_PAID,
  ACTION_TYPE_USE_SHIPMENT_NOTIFICATION_TEMPLATE,
  ACTION_TYPE_USE_PACKING_SLIP,
  ACTION_TYPE_ADD_NOTE_TO_BUYER,
  ACTION_TYPE_ASSIGN_TO_USER,
  ACTION_TYPE_BILL_INTL_DUTIES_TO_PAYOR,
  ACTION_TYPE_DONT_PREPAY_POSTAGE,
  ACTION_TYPE_CHARGE_SHIPPING_TO_THIRD_PARTY,
  ACTION_TYPE_SET_FULFILLMENT_PROVIDER,
  ACTION_TYPE_DONT_NOTIFY_MARKETPLACE_OF_SHIPMENT,
  ACTION_TYPE_SET_CUSTOM_FIELD_ONE,
  ACTION_TYPE_SET_CUSTOM_FIELD_TWO,
  ACTION_TYPE_SET_CUSTOM_FIELD_THREE,
  ACTION_TYPE_ENABLE_SATURDAY_DELIVERY,
  ACTION_TYPE_SET_ORER_AS_CONTAINING_ALCOHOL,
  ACTION_TYPE_SET_ORER_AS_CONTAINING_DRY_ICE,
  ACTION_TYPE_ENABLE_SHIPPER_RELEASE,
  ACTION_TYPE_SET_DRY_ICE_WEIGHT,
  ACTION_TYPE_SET_DECLARATION_STATEMENT,
  ACTION_TYPE_INCLUDE_RETURN_LABEL_WITH_OUTBOUND,
  ACTION_TYPE_USE_DELIVERY_NOTIFICATION_EMAIL_TEMPLATE,
  ACTION_TYPE_SET_ORDER_AS_DANGEROUS_GOODS,
  ACTION_TYPE_SET_SHIP_BY_DATE,
  ACTION_TYPE_COLLECT_PAYMENT_ON_DELIVERY,
  ACTION_TYPE_CHARGE_SHIPPING_TO_MY_ACCOUNT,
  ACTION_TYPE_SET_SERVICE_COLLECTION,
  ACTION_TYPE_SET_PREPAY_DUTIES_AND_TAXES,
  ACTION_TYPE_USE_BLANK_BOX,
  ACTION_TYPE_BLOCK_AMAZON_LOGISTICS,
  ACTION_TYPE_DELEGATE_TO_ASSIGNED_FULFILLMENT_PROVIDER,
  ACTION_TYPE_SEND_CARRIER_NOTIFICATIONS,
  ACTION_TYPE_SET_DELIVER_BY_DATE,
  ACTION_TYPE_SET_CONTAINS_DANGEROUS_GOODS,
  ACTION_TYPE_ADD_SHIPMENT_ITEM,
  ACTION_TYPE_ADD_IMPORTER_OF_RECORD,
  ACTION_TYPE_ADD_SERVICE_LEVEL_ROYAL_MAIL,
  ACTION_TYPE_SET_SHIP_DATE,
  ACTION_TYPE_RUN_PACKING_RECOMMENDATION,
  ACTION_TYPE_ADD_MOVEMENT_INDICATOR,
  ACTION_TYPE_READY_TO_PICK,
} from '../../../../constants/action-types';
import AddTag from '../components/action-value-input/add-tag';
import AddTaxIdentifiers from '../components/action-value-input/add-tax-identifiers';
import AppBasedEnumDropdown from '../components/action-value-input/app-based-enum-dropdown';
import DBBasedCollectionDropdown from '../components/action-value-input/db-based-collection-dropdown';
import ChargeShippingToThirdParty from '../components/action-value-input/charge-shipping-to-third-party';
import CollectPaymentOnDelivery from '../components/action-value-input/collect-payment-on-delivery';
import CreateAlert from '../components/action-value-input/create-alert';
import HoldOrderFor from '../components/action-value-input/hold-order-for';
import SetPackageDimensions from '../components/action-value-input/set-package-dimensions';
import SetFulfillmentProvider from '../components/action-value-input/set-fulfillment-provider';
import SetCarrierServicePackage from '../components/action-value-input/set-carrier-service-package';
import SetServiceCollection from '../components/action-value-input/set-service-collection';
import SendAnEmail from '../components/action-value-input/send-an-email';
import HoldUntil from '../components/action-value-input/hold-until';
import SetOrderAsDangerousGoods from '../components/action-value-input/set-order-dangerous-goods';
import SetDateFromDaysAfterOrderDate from '../components/action-value-input/set-date-from-days-after-order-date';
import TextAreaInput from '../components/action-value-input/text-area-input';
import TextInput from '../components/action-value-input/text-input';
import SellerDefaultWeightInput from '../components/action-value-input/weight-input';
import SetPrepayDutiesAndTaxes from '../components/action-value-input/set-prepay-duties-and-taxes';
import NoInputComponent from '../components/no-input-component';
import { CarrierNotifications } from '../components/action-value-input/notifications/carrier-notifications/carrier-notifications';
import SetDaysAroundDate from '../components/action-value-input/set-days-after-date/set-days-around-date';
import SetContainsDangerousGoods from '../components/action-value-input/set-contains-dagerous-goods';
import { AddShipmentItem } from '../components/action-value-input/add-shipment-item';
import { AddIOR } from '../components/action-value-input/add-ior/add-ior';
import { ShipFromLocationSearchableDropdown } from '../components/action-value-input/ship-from-location-searchable-dropdown';
import { ShippingAccountSearchableDropdown } from '../components/action-value-input/shipping-account-searchable-dropdown';
import { UserSearchableDropdown } from '../components/action-value-input/user-searchable-dropdown';
import { AddServiceLevelRoyalMail } from '../components/action-value-input/add-service-level-royal-mail/add-service-level-royal-mail';
import SetShipDate from '../components/action-value-input/set-ship-date/set-ship-date';
import { AddMovementIndicator } from '../components/action-value-input/add-movement-indicator/add-movement-indicator';

const actionTypeToInputType = {
  [ACTION_TYPE_ADD_TAG]: AddTag,
  [ACTION_TYPE_ADD_TAX_IDENTIFERS]: AddTaxIdentifiers,
  [ACTION_TYPE_SET_CARRIER_SERVICE_PACKAGE]: SetCarrierServicePackage,
  [ACTION_TYPE_INSURE_PACKAGE]: AppBasedEnumDropdown,
  [ACTION_TYPE_REQUEST_CONFIRMATION]: AppBasedEnumDropdown,
  [ACTION_TYPE_ADD_INTERNAL_NOTE]: TextAreaInput,
  [ACTION_TYPE_HOLD_ORDER_FOR]: HoldOrderFor,
  [ACTION_TYPE_SET_CUSTOMS_CONTENT_TYPE]: AppBasedEnumDropdown,
  [ACTION_TYPE_SET_INTERNATIONAL_NON_DELIVERY]: AppBasedEnumDropdown,
  [ACTION_TYPE_SET_SHIP_FROM_LOCATION]: ShipFromLocationSearchableDropdown,
  [ACTION_TYPE_STOP_PROCESSING_RULES]: NoInputComponent,
  [ACTION_TYPE_SEND_AN_EMAIL]: SendAnEmail,
  [ACTION_TYPE_CREATE_ALERT]: CreateAlert,
  [ACTION_TYPE_SET_ORDER_TOTAL_WEIGHT]: SellerDefaultWeightInput,
  [ACTION_TYPE_SET_PACKAGE_DIMENSIONS]: SetPackageDimensions,
  [ACTION_TYPE_DONT_IMPORT_ORDER]: NoInputComponent,
  [ACTION_TYPE_ADJUST_ORDER_WEIGHT]: SellerDefaultWeightInput,
  [ACTION_TYPE_HOLD_UNTIL]: HoldUntil,
  [ACTION_TYPE_MARK_SHIPMENT_NON_MACHINABLE]: NoInputComponent,
  [ACTION_TYPE_SHOW_POSTAGE_PAID]: NoInputComponent,
  [ACTION_TYPE_USE_SHIPMENT_NOTIFICATION_TEMPLATE]: DBBasedCollectionDropdown,
  [ACTION_TYPE_USE_PACKING_SLIP]: DBBasedCollectionDropdown,
  [ACTION_TYPE_ADD_NOTE_TO_BUYER]: TextAreaInput,
  [ACTION_TYPE_ASSIGN_TO_USER]: UserSearchableDropdown,
  [ACTION_TYPE_BILL_INTL_DUTIES_TO_PAYOR]: NoInputComponent,
  [ACTION_TYPE_DONT_PREPAY_POSTAGE]: NoInputComponent,
  [ACTION_TYPE_CHARGE_SHIPPING_TO_THIRD_PARTY]: ChargeShippingToThirdParty,
  [ACTION_TYPE_SET_FULFILLMENT_PROVIDER]: SetFulfillmentProvider,
  [ACTION_TYPE_DONT_NOTIFY_MARKETPLACE_OF_SHIPMENT]: NoInputComponent,
  [ACTION_TYPE_SET_CUSTOM_FIELD_ONE]: TextInput,
  [ACTION_TYPE_SET_CUSTOM_FIELD_TWO]: TextInput,
  [ACTION_TYPE_SET_CUSTOM_FIELD_THREE]: TextInput,
  [ACTION_TYPE_ENABLE_SATURDAY_DELIVERY]: NoInputComponent,
  [ACTION_TYPE_SET_ORER_AS_CONTAINING_ALCOHOL]: NoInputComponent,
  [ACTION_TYPE_SET_ORER_AS_CONTAINING_DRY_ICE]: NoInputComponent,
  [ACTION_TYPE_ENABLE_SHIPPER_RELEASE]: NoInputComponent,
  [ACTION_TYPE_SET_DRY_ICE_WEIGHT]: SellerDefaultWeightInput,
  [ACTION_TYPE_SET_DECLARATION_STATEMENT]: TextInput,
  [ACTION_TYPE_INCLUDE_RETURN_LABEL_WITH_OUTBOUND]: SetCarrierServicePackage,
  [ACTION_TYPE_SET_SERVICE_COLLECTION]: SetServiceCollection,
  [ACTION_TYPE_SET_PREPAY_DUTIES_AND_TAXES]: SetPrepayDutiesAndTaxes,
  [ACTION_TYPE_USE_DELIVERY_NOTIFICATION_EMAIL_TEMPLATE]: DBBasedCollectionDropdown,
  [ACTION_TYPE_SET_ORDER_AS_DANGEROUS_GOODS]: SetOrderAsDangerousGoods,
  [ACTION_TYPE_SET_SHIP_BY_DATE]: SetDaysAroundDate,
  [ACTION_TYPE_COLLECT_PAYMENT_ON_DELIVERY]: CollectPaymentOnDelivery,
  [ACTION_TYPE_CHARGE_SHIPPING_TO_MY_ACCOUNT]: ShippingAccountSearchableDropdown,
  [ACTION_TYPE_USE_BLANK_BOX]: NoInputComponent,
  [ACTION_TYPE_BLOCK_AMAZON_LOGISTICS]: NoInputComponent,
  [ACTION_TYPE_UNDEFINED]: NoInputComponent,
  [ACTION_TYPE_DELEGATE_TO_ASSIGNED_FULFILLMENT_PROVIDER]: DBBasedCollectionDropdown,
  [ACTION_TYPE_SEND_CARRIER_NOTIFICATIONS]: CarrierNotifications,
  [ACTION_TYPE_SET_DELIVER_BY_DATE]: SetDateFromDaysAfterOrderDate,
  [ACTION_TYPE_SET_CONTAINS_DANGEROUS_GOODS]: SetContainsDangerousGoods,
  [ACTION_TYPE_ADD_SHIPMENT_ITEM]: AddShipmentItem,
  [ACTION_TYPE_ADD_IMPORTER_OF_RECORD]: AddIOR,
  [ACTION_TYPE_ADD_SERVICE_LEVEL_ROYAL_MAIL]: AddServiceLevelRoyalMail,
  [ACTION_TYPE_SET_SHIP_DATE]: SetShipDate,
  [ACTION_TYPE_RUN_PACKING_RECOMMENDATION]: NoInputComponent,
  [ACTION_TYPE_ADD_MOVEMENT_INDICATOR]: AddMovementIndicator,
  [ACTION_TYPE_READY_TO_PICK]: NoInputComponent,
};

export const actionTypeIdHasMatchingComponent = (actionTypeId) => !!actionTypeToInputType[actionTypeId];

export const actionValueInputFromActionType = (actionType) => {
  if (!actionType || !actionTypeToInputType[actionType]) {
    return actionTypeToInputType[ACTION_TYPE_UNDEFINED];
  }
  return actionTypeToInputType[actionType];
};
